import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserGroup, GroupFeatureViewModel, GroupFeature } from './userGroup.model';
import { Observable } from 'rxjs';
import { Feature } from './feature.model';
import { Permission } from './permission.enum';

@Injectable({
    providedIn: 'root'
})
export class FeatureManagementDataService {
    private groupsApiUrl = 'api/groups';
    private featureApiUrl = 'api/feature';
    private readonly options = { headers: {
            'Content-Type' : 'application/json'
        }
    };
    constructor(
        private http: HttpClient
    ) { }

    public features(): Observable<Feature[]> {
        return this.http.get<Feature[]>(
            this.featureApiUrl);
    }

    public groups(): Observable<UserGroup[]> {
        return this.http.get<UserGroup[]>(this.groupsApiUrl, this.options);
    }
    
    setGroupFeature(groupFeature: GroupFeatureViewModel): Observable<any> {
        const permission = groupFeature.HasPermission ? Permission.Allow : Permission.Deny;
        return this
            .http.post<void>(
                `${this.featureApiUrl}/groupfeatures/${groupFeature.GroupId}/${groupFeature.FeatureName}/${permission}`, 
                null,
                this.options);
    }

    public deleteGroup(groupId): Observable<any> {
        return this
            .http
            .delete(
                `${this.groupsApiUrl}/${groupId}`,
                this.options
            );
    }

    public addGroup(groupName: string, groupId: string): Observable<any> {
        return this
            .http
            .post(this.groupsApiUrl, {
                Id: groupId,
                Name: groupName
            },
                this.options
            );
    }

    public groupFeatures(): Observable<GroupFeature[]> {
        return this.http.get<GroupFeature[]>(`${this.featureApiUrl}/groupfeatures/`);
    }
}